import React from 'react';
import { CSVReader } from 'react-papaparse';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import AutoComplete from '@mui/material/Autocomplete';
import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';

function AcumaticaUploadForm(props) {

    return(
        <Box className = {props.isMobile ? "mobile-box" : "desktop-box"} display = "flex" flexDirection = "column">
            <Stack direction = "row" alignItems = {"center"}>
                <FormControl sx = {{ width: '25%', mr: '0.6%' }}>
                    <AutoComplete
                        value = {props.vendor_options.find(option => option.value === props.vendor) || null}
                        onChange = {(event, newValue) => {
                            props.setVendor(newValue ? newValue.value : null);
                        }}
                        id = "vendor"
                        options = {props.vendor_options}
                        getOptionLabel = {(option) => {
                            return `${option.name}`;
                        }}
                        renderOption = {(props, option) => {
                            return (
                                <li {...props}>
                                    {`${option.name}`}
                                </li>
                            );
                        }}
                        renderInput = {(params) => (
                            <TextField {...params} label = "Vendor" />
                        )}
                    />
                </FormControl> 
                { props.vendor ? 
                    <CSVReader
                        ref = {props.buttonRef}
                        onFileLoad = {props.handleOnFileLoad}
                        onError = {props.handleOnError}
                        noClick
                        noDrag
                        config = {{
                            header: true,
                            skipEmptyLines: true
                        }}
                        style = {{ marginTop: "20px", marginBottom: "20px" }}
                        >
                        {({ file }) => (
                            <aside style = {{marginTop: "20px", marginBottom: "20px"}}>
                                <Stack direction = "row" spacing = {2} sx = {{alignItems: 'center', mt: 2}}>
                                    <Button 
                                        variant = 'contained' 
                                        onClick = {props.handleOpenDialog} 
                                        className = {`${props.company} ${props.warehouse} secondary`}
                                        disabled = {props.loading}
                                    >
                                        Browse file
                                    </Button>
                                    <div>
                                        {file?.name}
                                    </div>
                                </Stack>
                                {props.file !== null ? 
                                    <Box>
                                        <Button 
                                            variant = 'contained' 
                                            sx = {{ mt: '10px' }} 
                                            onClick = {props.uploadFile} 
                                            className = {`${props.company} ${props.warehouse} secondary`}
                                            disabled = {props.loading}
                                        >
                                            Upload
                                        </Button>
                                        <Button 
                                            variant = 'contained' 
                                            sx = {{ mt: '10px', ml: '10px' }} 
                                            onClick = {props.handleRemoveFile} 
                                            className = {`${props.company} ${props.warehouse} tertiary`}
                                            disabled = {props.loading}
                                        >
                                            Remove
                                        </Button>
                                    </Box>
                                : null}
                            </aside>
                        )}
                    </CSVReader>
                : null }
            </Stack>
      </Box>
    );
  };

export default AcumaticaUploadForm;